import { render, staticRenderFns } from "./ApiConnectionsForm.vue?vue&type=template&id=a80431f8&"
import script from "./ApiConnectionsForm.vue?vue&type=script&lang=js&"
export * from "./ApiConnectionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports